'use client';

import Script from 'next/script';
import { NAVER_WA_ACCOUNT_ID } from '@/lib/naver';

export default function NaverAnalytics() {
  return (
    <Script data-component-id="src/components/common/NaverAnalytics.tsx:8:4" data-component-path="src/components/common/NaverAnalytics.tsx" data-component-line="8" data-component-end-line="21" data-component-file="NaverAnalytics.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%2C%22src%22%3A%22https%3A%2F%2Fwcs.naver.net%2Fwcslog.js%22%7D"
      src="https://wcs.naver.net/wcslog.js"
      strategy="afterInteractive"
      onLoad={() => {
        const w = window as any;
        if (!w.wcs_add) w.wcs_add = {};
        w.wcs_add['wa'] = NAVER_WA_ACCOUNT_ID;
        if (!w._nasa) w._nasa = {};
        if (w.wcs) {
          w.wcs.inflow();
          w.wcs_do();
        }
      }}
    />
  );
}
